import { useQuery } from "@tanstack/react-query";
import { getVoice } from "../lib/api";

export const useVoice = () =>
  useQuery({
    queryKey: ["voice"],
    queryFn: getVoice,
    staleTime: 30_000,
  });
